<template>
    <a-row>
        <a-col :span="6">
            <p>Hub message is disconnected</p>
            
        </a-col>
    </a-row>
</template>

<script>
export default {
    name: 'DisconnectMessageCard',
    props : {
        
    },
    methods : {

    }
}
</script>
<style lang="scss">
.details{
margin-left: 10px;
}
</style>
